import ImprovedSearchExperience from '../../../assets/improved_search_experience_whats_new.png';
import FacilitiesEquipmentWhatsNew from '../../../assets/facilities_equipment_tab_whats_new.png';
import TicketTabSearchWhatsNew from '../../../assets/ticket_search_whats_new.png';
import ServiceHistoryWhatsNew from '../../../assets/service_history_whats_new.png';
import UnifiedFacilitiesWhatsNew from '../../../assets/unified_facilities_whats_new.png';
import { IntroductionInterface } from '../../../interfaces/IntroductionInterface';

export const whatsNewSlides: IntroductionInterface[] = [
  {
    id: 'slide_1',
    featureFlag: 'enable-unified-facilities-intake-whats-new',
    header: 'The new Facilities form is now available',
    headerMobile: 'The new Facilities form is now available',
    description:
      'You can now open support tickets for facilities items such as shelving, tiles, HVAC, and roofing directly from the CFA Support App and on the web.',
    button: {
      label: 'Open a facilities ticket',
      href: '/forms/49eeb82e3bf44b10e22c4db693e45ad4',
    },
    image: UnifiedFacilitiesWhatsNew,
    alt: 'Unified Facilities Whats New Image',
    kbArticle: undefined,
  },
  {
    id: 'slide_2',
    featureFlag: 'enable-restaurant-service-history',
    header: 'Upload service records on your equipment',
    headerMobile: 'Upload service records on your equipment',
    bulletItems: [
      {
        label:
          "You can now add your own service history records to your Restaurant's kitchen equipment. Attach invoices, track costs, and other details about equipment repairs and service.",
      },
    ],
    bulletItemsMobile: [
      {
        label:
          "You can now add your own service history records to your Restaurant's kitchen equipment. Attach invoices, track costs, and other details about equipment repairs and service.",
      },
    ],
    image: ServiceHistoryWhatsNew,
    alt: 'Service History Whats New Image',
    kbArticle: undefined,
  },
  {
    id: 'slide_3',
    header: 'Find and manage your tickets faster',
    headerMobile: 'Find and manage your tickets faster',
    bulletItems: [
      {
        label:
          "We've added a new search experience to the Tickets tab to help you find your support tickets more quickly.",
      },
      {
        label:
          "You can also refine results using ticket filters to locate specific tickets faster. We've also updated the tickets to provide clearer, more consistent information so you can quickly understand the status and details that matter most.",
      },
    ],
    bulletItemsMobile: [
      {
        label:
          "We've added a new search experience to the Tickets tab to help you find your support tickets more quickly.",
      },
      {
        label:
          "You can also refine results using ticket filters to locate specific tickets faster. We've also updated the tickets to provide clearer, more consistent information so you can quickly understand the status and details that matter most.",
      },
    ],
    image: TicketTabSearchWhatsNew,
    alt: 'Ticket Tab Search Whats New Image',
    kbArticle: undefined,
  },
  {
    id: 'slide_4',
    header: 'Find facilities in the Equipment tab',
    headerMobile: 'Find facilities in the Equipment tab',
    description:
      "The new Restaurant facilities section in the Equipment tab highlights common facility items and provides helpful details before you submit a request. From there, you'll be directed to the correct form when you're ready to submit a ticket.",
    button: {
      label: 'Check out facilities in Equipment',
      href: '/equipment#restaurant-facilities',
    },
    image: FacilitiesEquipmentWhatsNew,
    alt: 'Find facilities in the Equipment tab Whats New Image',
    kbArticle: undefined,
  },
  {
    id: 'slide_5',
    header: 'You can now search your tickets!',
    headerMobile: 'You can now search your tickets!',
    bulletItems: [
      {
        label:
          'You asked, we delivered! Now you can search through Support tickets to find the information you need more quickly and easily. Find past and current tickets by searching keywords, ticket number, or comments.',
      },
      {
        label:
          "Please note: This feature is being rolled out gradually, so it may not yet be available to all Team Members. We're working behind the scenes to get all Team Members access.",
      },
    ],
    bulletItemsMobile: [
      {
        label:
          'You asked, we delivered! Now you can search through Support tickets to find the information you need more quickly and easily. Find past and current tickets by searching keywords, ticket number, or comments.',
      },
      {
        label:
          "Please note: This feature is being rolled out gradually, so it may not yet be available to all Team Members. We're working behind the scenes to get all Team Members access.",
      },
    ],
    image: ImprovedSearchExperience,
    alt: 'Improved search experience image',
    kbArticle: undefined,
  },
];
